const env = process.env.VUE_APP_ENV;

let envApiUrl = '';
let envWebsocketUrl = '';
let envStaticUrl = '';
let envStaticScrapperUrl = '';
let envGraphqlUrl = '';


if (env === 'production') {
  envApiUrl = `https://${process.env.VUE_APP_DOMAIN_PROD}/api/v1`;
  envStaticUrl = `https://${process.env.VUE_APP_DOMAIN_PROD}`;
  envWebsocketUrl = `wss://${process.env.VUE_APP_DOMAIN_PROD}`;
  envStaticScrapperUrl = `https://${process.env.VUE_APP_DOMAIN_PROD}`;
  envGraphqlUrl = `https://${process.env.VUE_APP_DOMAIN_PROD}/graphql`;
} else if (env === 'staging') {
  envApiUrl = `https://${process.env.VUE_APP_DOMAIN_STAG}/api/v1`;
  envStaticUrl = `https://${process.env.VUE_APP_DOMAIN_STAG}`;
  envWebsocketUrl = `wss://${process.env.VUE_APP_DOMAIN_STAG}`;
  envStaticScrapperUrl = `https://${process.env.VUE_APP_DOMAIN_STAG}`;
  envGraphqlUrl = `https://${process.env.VUE_APP_DOMAIN_STAG}/graphql`;
} else {
  envApiUrl = `http://${process.env.VUE_APP_DOMAIN_DEV}/api/v1`;
  envStaticUrl = `http://${process.env.VUE_APP_DOMAIN_DEV}`;
  envWebsocketUrl = `ws://${process.env.VUE_APP_DOMAIN_DEV}`;
  envGraphqlUrl = `http://${process.env.VUE_APP_DOMAIN_DEV}/graphql`;
  envStaticScrapperUrl = `http://${process.env.VUE_APP_SCRAPPER_URL}/static`;
  // envStaticScrapperUrl = `http://${process.env.VUE_APP_SCRAPPER_URL}/static_scrapper`;
}

export const apiUrl = envApiUrl;
export const staticUrl = envStaticUrl;
export const socketUrl = envWebsocketUrl;
export const appName = process.env.VUE_APP_NAME;
export const arkandhaUrl = process.env.VUE_APP_ARKANDHA_MAIN_URL;
export const staticScrapperUrl = envStaticScrapperUrl;
export const arkandhaApiUrl = process.env.VUE_APP_ARKANDHA_API_URL;
export const arkandhaGeoserverUrl = process.env.VUE_APP_ARKANDHA_GEOSERVER_URL;
export const graphqlUrl = envGraphqlUrl;
